import React, {useState, useEffect, createRef, useContext} from "react"
import {buildClassList} from "../helpers/utilities"
import {CONTAINER_LG, TOP_OFFSET} from "../helpers/constants"
import IRSLogo from "../Icons/IRSLogo"
import {HeaderNavItem} from "../IRSHeader"
import NavBarItem from "./NavBarItem"
import SiteContext from "../context/SiteContext"

const NavBar = ({items, className, headerNavItems, ...rest}) => {
  const {menuState, width} = useContext(SiteContext)

  const [navTop, setNavTop] = useState(1)
  const [navItemTop, setNavItemTop] = useState(0)

  useEffect(() => {
    window.addEventListener(
      "scroll",
      ev => {
        const navDiv = document.getElementById("nav-container")
        if (navDiv) {
          setNavTop(navDiv.getBoundingClientRect().top)
          setNavItemTop(Math.round(navDiv.getBoundingClientRect().bottom) - TOP_OFFSET)
        }
      },
      {
        capture: true,
        passive: true
      }
    )
  }, [])

  const mainNavBarItems =
    items &&
    Object.values(items).map(
      ({href, text, key, active, type, columns, isOpen}) => {
        return (
          <NavBarItem
            key={key}
            columnKey={key}
            href={href}
            active={active}
            type={type}
            columns={columns}
            top={navItemTop}
            isOpen={isOpen}
            navTop={navTop}
          >
            {text}
          </NavBarItem>
        )
      }
    )

  const secondMenu =
    headerNavItems &&
    headerNavItems.map(({text, ...rest}, i) => {
      return (
        i !== 0 && (
          <HeaderNavItem languageButton="navLangButton" {...rest}>
            {text}
          </HeaderNavItem>
        )
      )
    })
    
  const ref = createRef()

  return (
    <nav
      id="nav-container"
      ref={ref}
      role="application"
      aria-label="Main Navigation"
      className={buildClassList(
        "navBar overflow-y-auto overflow-x-hidden bg-blue-600 lg:overflow-visible lg:bg-blue-700 z-30",
        width >= CONTAINER_LG ? "isStickyNav" : "absolute slideOut h-full",
        "lg:w-auto lg:block ",
        menuState ? "block slideIn " : "hidden",
        parseInt(navTop) <= 0 ? "isStickyLogo" : ""
      )}
      {...rest}
    >
      <ul className={buildClassList(
        "navList flex flex-col h-auto lg:flex-row lg:mx-auto",
        width >= CONTAINER_LG && "container"
      )}>
        <li className="navItem logo-nav hidden">
          <a href="https://www.irs.gov/">
            <IRSLogo className="h-6 w-16 mt-2-5 mr-5 text-white" focusable="false"/>
          </a>
        </li>
        {mainNavBarItems}
      </ul>

      <ul className="secondMenu h-auto lg:hidden bg-blue-600 text-white pb-32 lg:pb-0 mt-2">
        {secondMenu}
      </ul>
    </nav>
  )
}

export default NavBar
